// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/main';

// ----------------------------------------------------------------------

export const ROOTS = {
  root: "/",
};

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login')
};

export const PATH_PAGE = {
  errorPage: '/error',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    analytics: path(ROOTS_DASHBOARD, '/analytics')
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    account: path(ROOTS_DASHBOARD, '/user/account')
  },
  skills: {
    root: path(ROOTS_DASHBOARD, '/skills'),
    global: `${ROOTS_DASHBOARD}/skills/global`,
    groups: `${ROOTS_DASHBOARD}/skills/groups`,
    new: `${ROOTS_DASHBOARD}/skills/new`,
    details: (id) => `${ROOTS_DASHBOARD}/skills/${id}`,
    edit: (id) => `${ROOTS_DASHBOARD}/skills/${id}/edit`,
    agents: path(ROOTS_DASHBOARD, '/skills/agents'),
    telephony: path(ROOTS_DASHBOARD, '/skills/telephony')
  },
  interface: {
    root: path(ROOTS_DASHBOARD, '/interface'),
    global: path(ROOTS_DASHBOARD, '/interface/global'),
    form: path(ROOTS_DASHBOARD, '/interface/form'),
    chat: path(ROOTS_DASHBOARD, '/interface/chat')
  },
  settings: {
    root: path(ROOTS_DASHBOARD, '/settings'),
    global: path(ROOTS_DASHBOARD, '/settings/global')
  }
};